<template>
  <small class="text-danger"> *</small>
</template>
<script>
export default {};
</script>
